import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Editor, toDoc, toHTML } from 'ngx-editor';
import { SubAccount } from 'src/app/models/sub_account_model';
import { User } from 'src/app/models/user_model';
import { EmailService } from 'src/app/services/email.service';
import { SubAccountService } from 'src/app/services/sub-account.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-subaccounts',
  templateUrl: './subaccounts.component.html',
  styleUrls: ['./subaccounts.component.css']
})
export class SubaccountsComponent implements OnInit {

  public user: User | null;
  public accounts: SubAccount[] = [];
  public account: SubAccount = {
    accountId: '',
    subaccountId: '',
    subaccountEmail: '',
    accountName: '',
    accountEmail: '',
    permissionType: 'none',
  }
  public isUnlimited: boolean = false;
  public addingCredits = 0;
  public newPassword: string = '';  
  public editingId = ''
  public editor:Editor;
  public html: any;
  public defaultEmail = true;
  public subject = 'Asignación de cuenta de evaluador';


  constructor(
    private userService: UserService,
    private accountService: SubAccountService,
    private route: ActivatedRoute,
    private router: Router, 
    private emailService:EmailService, 
    
  ) { }

  async ngOnInit() {

    let userId = this.route.snapshot.paramMap.get('userId');
    this.user = await this.userService.getUserByQuery({_id: userId}).toPromise();
    if (!this.user){
      this.router.navigate(['/dashboard']);
      return;
    }
    this.accounts = await this.accountService.getSubAccounts({accountId: this.user._id}).toPromise();
    setTimeout(() => {
      this.initEditor();
    }, 1000);
  }

  initEditor(){
    if (this.editor) {
      this.editor.destroy();
    }
    this.editor = new Editor();

    let html = `
    <div style="width:100%; justify-content:center">
        <div style="width:700px">
        
            <h3>Estimado/a:</h3>
            <p>Le informamos que ha sido asignado/a como evaluador/a en la plataforma: <a href="http://www.evaluapsi.com">http://www.evaluapsi.com</a> a continuación, encontrará el acceso al sistema.</p>

        
        </div>
    
    
    </div>
        
    `;


    this.html = toDoc(html);
  }


  sendAccountEmail(user: User, password: string) {
    let html;
    if (this.html.type == "doc"){
      html = toHTML(this.html);
    }else{
      html = this.html;
    }
    html = `
      ${html}
      <h3>Datos de acceso:</h3>
      <i>
          <p>Link de Login: <a href="http://www.evaluapsi.com">http://www.evaluapsi.com</a></p>
          <p>Usuario: ${user.email}</p>
          ${password.length > 0 ? `<p>Contraseña: ${password}</p>` : ''}
      </i>  
      <p>Saludos cordiales</p>
    `

    let data = {
      email: user.email,
      password:password,
      html:html,
      subject: this.subject,
    }    
    this.emailService.evaluatedRegister(data).subscribe();
  }

  async handleCreateAccount(){
    if (!this.account.subaccountEmail){
      return;
    }

    if (this.addingCredits < 0){
      Swal.fire({
        icon: 'error',
        text: 'No puedes añadir créditos negativos.',
      });
      return;
    }

    if (this.accounts.length >= this.user.subaccountLimit ){
      Swal.fire({
        icon: 'error',
        text: 'Has alcanzado el límite de cuentas secundarias.',
      });
      return;
    }

    if (this.user.remainingTests < this.addingCredits && !this.isUnlimited){
      Swal.fire({
        icon: 'error',
        text: 'No tienes suficientes créditos para crear una cuenta secundaria.',
      });
      return;
    }

    let accountUser = await this.userService.getUserByEmail(this.account.subaccountEmail.toLocaleLowerCase()).toPromise().catch(() => {
      $('.new-user-modal').modal('show');
      return;
    });
    if (!accountUser){
      $('.new-user-modal').modal('show');
      return;
    }
    if (accountUser.role !== 'client') {
      Swal.fire({
        icon: 'error',
        text: 'Esta cuenta no se encuentra habilitada para ser una cuenta secundaria.',
      });
      return;
    }
    this.account.subaccountId = accountUser._id;
    this.account.subaccountEmail = accountUser.email.toLocaleLowerCase();
    this.account.accountId = this.user._id;
    this.account.accountName = this.user.name + ' ' + this.user.surname;
    this.account.accountEmail = this.user.email;
    if (!this.editingId){
      let res = await this.accountService.createSubAccount(this.account).toPromise()
      this.accounts.push(res);
    }else{
      await this.accountService.updateSubAccount(this.editingId, this.account).toPromise();
      this.account = {
        accountId: '',
        subaccountId: '',
        subaccountEmail: '',
        accountName: '',
        accountEmail: '',
        permissionType: 'none',
      };
      this.editingId = '';

    }
    let updated = await this.userService.updateUser({
      email: accountUser.email,
      isUnlimited: this.isUnlimited,
      remainingTests: (accountUser.remainingTests + this.addingCredits) || 0,
      active: true,
      isEnterprise: true,
      enterpriseExpireDate: this.user.enterpriseExpireDate,
      canUseCustomTests: this.user.canUseCustomTests,
      canUseTestCreator: this.user.canUseTestCreator,
    }).toPromise();
    this.addingCredits = 0;

    if (updated && !this.user.isUnlimited) {
      this.user.remainingTests -= this.addingCredits;
      await this.userService.updateUser(this.user).toPromise();
    }
    this.sendAccountEmail(accountUser, this.newPassword);
    Swal.fire({
      icon: 'success',
      text: 'Cuenta secundaria actualizada',
    }).then(() => {
      location.reload();
    })
  }

  async createAccount() {
    let newUser: User = {
      email: this.account.subaccountEmail.toLocaleLowerCase(),
      password: this.newPassword,
      name: '',
      surname: '',
      role: 'client',
      isUnlimited: this.isUnlimited,
      remainingTests: this.addingCredits,
      active: true,
      registerDate: new Date(),
      daysLeft: 0,
      plan: 'free',
      paymentsHistory: [],
      testsHistory: [],
      notes: '',
      alias: '',
      birthDate: new Date(),
      country: '',
      city: '',
      phone: '',
      profession: '',
      company: '',
      studies: '',
      lastPurchase: new Date(),
      firstBuy: true,
      isCustomBrand: false,
      logoUrl: '',
      logoLink: '',
      customColor: '',
      canUseCustomTests: this.user.canUseCustomTests,
      canUseTestCreator: this.user.canUseTestCreator,
      subscriptionStart: new Date(),
      subscriptionEnd: new Date(),
      subscriptionType: '',
      subscriptionId: '',
      subscriptionCancelled: false,
      useMp: false,
      demoSubscription: false,
      demoSubscriptionEnd: new Date(),
      isEnterprise: true,
      enterpriseExpireDate: this.user.enterpriseExpireDate,
      subaccountLimit: 0,
      sex: '',
    }
    try {
      await this.userService.register(newUser).toPromise();
      $('.new-user-modal').modal('hide');
      this.handleCreateAccount();
    } catch (error) {
      alert('Error creating account: ' + error);
    }
  }

  handleDeleteAccount(account: SubAccount) {
    Swal.fire({
      title: '¿Estás seguro?',
      text: `¿Deseas eliminar la cuenta secundaria de ${account.subaccountEmail}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let restoredCredits = 0;
          let accountUser = await this.userService.getUserByEmail(account.subaccountEmail).toPromise();
          restoredCredits = accountUser.remainingTests || 0;
          if (this.user.isUnlimited) {
            restoredCredits = 0;
          }
          let deleted = await this.accountService.deleteSubAccount(account._id).toPromise();
          await this.userService.updateUser({
            _id: accountUser._id,
            email: accountUser.email,
            remainingTests: 0,
            isUnlimited: false,
            isEnterprise: false,
            canUseCustomTests: false,
            canUseTestCreator: false,
            enterpriseExpireDate: this.user.enterpriseExpireDate,
            
          }).toPromise();

          if (deleted && restoredCredits > 0) {
            if (!this.user.isUnlimited) {
              this.user.remainingTests += restoredCredits;
              await this.userService.updateUser(this.user).toPromise();
            }
          }
          this.accounts = this.accounts.filter(acc => acc._id !== account._id);
          Swal.fire({
            icon: 'success',
            text: 'Cuenta secundaria eliminada correctamente',
          }).then(() => {
            location.reload();
          })
        } catch (error) {
          Swal.fire({
            icon: 'error',
            text: 'Error al eliminar la cuenta secundaria',
          });
        }
      }
    })
  }

  async handleEditAccount(account: SubAccount) {
    this.account = { ...account };
    this.editingId = account._id;
    let userAccount = await this.userService.getUserByEmail(account.subaccountEmail).toPromise();
    if (!userAccount) {
      Swal.fire({
        icon: 'error',
        text: 'No se pudo encontrar el usuario asociado a esta cuenta secundaria.',
      });
      return;
    }

    this.isUnlimited = userAccount.isUnlimited || false;
    this.scrollToTop();
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  checkMinCredits(){
    setTimeout(() => {
      if (this.addingCredits < 0) {
        this.addingCredits = 0;
      }
    }, 100)
  }

}
